import type { FC } from 'react';

import { cn } from '@repo/utils/common';

interface ProgressBarProps {
  className?: string;
}

export const ProgressBar: FC<ProgressBarProps> = ({ className }) => {
  return <div className={cn('progress bg-primary h-1 w-full', className)} />;
};
